export default "__VITE_ASSET__BRrosVWk__"